module.exports = __webpack_public_path__ + "img/65.7.Chla.145f0b61.png";